import ActionBroadcastChannel from 'src/store/broadcast/ActionBroadcastChannel';
function actionBroadcastMiddleware(store) {
    return (next) => (action) => {
        ActionBroadcastChannel.run(store, action);
        return next(action);
    };
}
export default actionBroadcastMiddleware;
